import clsx from "classnames";
import { Container, Stack } from "react-bootstrap";
import { SiteFooterCopyright, SiteFooterDetails, SiteFooterNav, SiteFooterSocials, SiteFooterBy } from "./__components";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getGlobal } from "@/functions/getGlobal";

export default function SiteFooter({ className }) {
  const global = getGlobal();
  const company_name = global["_theme.company.name"];
  const footer_bg = global["_theme.footer.bg"];

  return (
    <div className={clsx(className, classes.footer, "pt-4 pb-4 bg-primary")} style={{ backgroundImage: `url(${footer_bg})` }}>
      <Container>
        <SiteFooterNav className={clsx(classes.footer__nav)} />
      </Container>
      <Container>
        <SiteFooterSocials
          className={clsx(classes.footer__socials, "justify-content-center justify-content-lg-start flex-grow-0")}
        />
      </Container>
      <Container className="text-center text-md-start">
        <div className={classes.footer__bottom}>
          <div className={classes.footer__cont}>
          <SiteFooterDetails className={clsx(classes.footer__details, "")} />
          </div>
          <div className={`${classes.footer__cont} ${classes.footer__cont2}`}>
          <SiteFooterCopyright className={clsx(classes.footer__copyright, "text-white")} />
          </div>
          <div className={`${classes.footer__cont} ${classes.footer__cont3}`}>
          <SiteFooterBy className={clsx(classes.footer__by, "text-white small")} />
          </div>
        </div>
      </Container>
    </div>
  );
}

SiteFooter.defaultProps = {
  className: "",
};

SiteFooter.propTypes = {
  className: PropTypes.string,
};
